import { Box, Stack } from "@mui/system";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Divider, Grid, Typography } from "@mui/material";
import CustomAppBar from "../../../components/CustomAppBar";
import { useLocation, useNavigate } from "react-router";
import RoundButton from "../../../components/RoundButton";

import { useDispatch, useSelector } from "react-redux";
import {
  availabilitySummaryRequest,
  fetchCalculatedPricesRequest,
  reservationsPricingRequest,
} from "../../../redux/reservations/action";
import CustomLoader from "../../../components/CustomLoader";
import VehicalTypeCard from "../../../components/reservation/VehicalTypeCard";
import moment from "moment-timezone";
import { enqueueSnackbar } from "notistack";
import selectedIcon from "../../../constants";
import { updateReservationCheckout } from "../../../redux/reservations/constants";
import MenuBar from "../../menuBar";
import { useResponsive } from "../../../hooks/useResponsive";
import SnackbarConfig from "../../../utils/snackbarConfig";
import useKeyboardOpen from "../../../hooks/useKeyboard";
import { convert24HourTo12Hour, truncateLocationName } from "../../../utils";
import { MOMENT_CONSTANTS, convertYardToUtc } from "../../../utils/momentUtils";
import { useTranslation } from "react-i18next";
import { getSpotTitle } from "../../../utils/utils";

const ReservationTypePage = React.memo(() => {
  const {
    isLoading,
    pricingList,
    availabilitySummaryData,
    reservationCheckoutData,
    spotThreshold,
  } = useSelector((state) => state.reservationReducer);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const lgUp = useResponsive("up", "lg");

  const [subTotalCost, setSubTotalCost] = useState(0);
  const [calculatedTax, setCalculatedTax] = useState(0);
  const [numberDaysCost, setNumberDaysCost] = useState(0);
  const [vehicleList, setVehiclesList] = useState([]);
  const [spotThresholdInf, setSpotThresholdInf] = useState([]);

  const selectedVehchilCount = useMemo(() => {
    let count = 0;
    for (let item of vehicleList) {
      count += item.selectedCount;
    }
    return count;
  }, [vehicleList]);

  useEffect(() => {
    if (selectedVehchilCount >= 10) {
      enqueueSnackbar(
        "Please contact our customer support at +1 786-649-7233 to book more than 10 spots.",
        {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        },
      );
    }
  }, [selectedVehchilCount]);

  const previousData = location.state;
  const currentDate = moment(previousData?.fromDate);
  const futureDate =
    previousData?.reservationType === "DAILY"
      ? moment(currentDate).add(previousData?.numOfDays, "days")
      : // : moment(currentDate).add(1, "months");
        currentDate.clone().endOf("month");

  const futureDate24Hours =
    previousData?.reservationType === "DAILY"
      ? moment(currentDate).add(previousData?.numOfDays, "days")
      : // : moment(currentDate).add(1, "months");
        currentDate.clone().endOf("month");
  const daysCount = moment(futureDate).diff(moment(currentDate), "days") + 1; /// add 1 day to add current days
  const daysDiffrence =
    previousData?.reservationType === "DAILY"
      ? `${previousData?.numOfDays} ${
          previousData?.numOfDays === 1
            ? "day"
            : `${t("pages.reservationType.text03")}`
        }`
      : `${daysCount} ${
          daysCount === 1 ? "day" : `${t("pages.reservationType.text03")}`
        }`;

  const typeOfReserVationDaySubTotal =
    previousData?.reservationType === "DAILY"
      ? `${t("pages.reservationType.text06")} ( ${t(
          "pages.reservationType.text03",
        )} )`
      : `${t("pages.reservationType.text06")} ( ${t(
          "pages.reservationType.text11",
        )} )`;

  useEffect(() => {
    if (!reservationCheckoutData?.vehicleList?.length > 0) {
      const hours = previousData?.time?.split(":")?.[0];
      const futureDate_params =
        previousData?.reservationType === "DAILY"
          ? moment(currentDate).add(previousData?.numOfDays, "days")
          : currentDate.clone().add(1, "month").endOf("month");

      const availabilityParam = {
        locationId: previousData?.locationId,
        reservationType: previousData?.reservationType,
        fromDate: convertYardToUtc({
          date: moment(previousData?.fromDate).set({ hour: hours }),
          timeZone: previousData?.reservationState?.timezone,
        }),

        toDate: convertYardToUtc({
          date: futureDate_params.set({ hour: 23, minute: 59, second: 59 }),
          timeZone: previousData?.reservationState?.timezone,
        }),
      };
      dispatch(availabilitySummaryRequest(availabilityParam, (response) => {}));
    }
  }, [previousData, pricingList]);

  useEffect(() => {
    if (pricingList?.length) {
      const finalPricingList = pricingList
        ?.filter(function (item) {
          return item.reservationType === previousData?.reservationType;
        })
        .map(function (item, index) {
          return { ...item, ...{ totalCost: 0, selectedCount: 0 } };
        });
      setVehiclesList([]);
      // const mergedArray = finalPricingList.concat(availabilitySummary);
      setVehiclesList(finalPricingList);
    }
  }, [pricingList, availabilitySummaryData]);

  useEffect(() => {
    if (!reservationCheckoutData?.vehicleList?.length > 0) {
      dispatch(
        reservationsPricingRequest(previousData?.locationId, (response) => {}),
      );
    }
    setSpotThresholdInf(spotThreshold);
  }, []);

  const calculatedSubTotal = (data) => {
    const total = data.reduce((accumulator, currentValue) => {
      return accumulator + currentValue?.totalCost;
    }, 0);

    setSubTotalCost(total.toFixed(2));
  };

  const calculatedTaxList = (data) => {
    const totalTax = data.reduce((accumulator, currentValue) => {
      return accumulator + currentValue?.taxRate * currentValue?.selectedCount;
    }, 0);
    setCalculatedTax(parseFloat(totalTax.toFixed(2)));
  };

  useEffect(() => {
    calculatedSubTotal(vehicleList);
    calculatedTaxList(vehicleList);
  }, [vehicleList]);

  useEffect(() => {
    if (previousData?.reservationType === "DAILY") {
      setNumberDaysCost(parseFloat(subTotalCost) * parseFloat(daysDiffrence));
    } else {
      setNumberDaysCost(parseFloat(subTotalCost));
    }
  }, [subTotalCost]);

  useEffect(() => {
    if (reservationCheckoutData?.vehicleList?.length > 0) {
      setVehiclesList(reservationCheckoutData?.vehicleList);
    }
  }, [reservationCheckoutData]);

  const isKeyboardOpen = useKeyboardOpen();

  const getSpotNumber = useCallback(
    (vehicleType) => {
      if (availabilitySummaryData) {
        return availabilitySummaryData.filter(
          (v) => v.spotType === vehicleType,
        )[0]?.count;
      }
      return 0;
    },
    [availabilitySummaryData],
  );

  return (
    <div
      style={{
        width: lgUp ? `calc(100% - ${240}px)` : "100%",
        marginLeft: lgUp ? "240px" : 0,
      }}
    >
      <CustomAppBar
        title={t("pages.reservationType.pageHeading")}
        showBackButton={true}
        onBackButtonClick={() => {
          navigate(-1);
        }}
      />
      <MenuBar />

      <Box
        maxHeight={"90vh"}
        overflow={"scroll"}
        sx={{
          m: lgUp ? 3.5 : 1,
          mb: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-around",
        }}
      >
        <Grid container direction={"column"} sx={{ mt: 2 }}>
          <Typography variant="h5" color={"primary.main"}>
            {t("pages.reservationType.title01")}
          </Typography>
          <Typography variant="body2" color={"primary.secondary"}>
            {previousData?.reservationType === "DAILY"
              ? `${t("pages.reservationType.text01")} ${currentDate?.format(
                  MOMENT_CONSTANTS.date.shortMonthDay,
                )} ${convert24HourTo12Hour(
                  previousData?.time,
                )} to ${futureDate24Hours?.format(
                  MOMENT_CONSTANTS.date.shortMonthDay,
                )} ${convert24HourTo12Hour(
                  previousData?.time,
                )} (${daysDiffrence})`
              : `${t("pages.reservationType.text01")} ${currentDate?.format(
                  MOMENT_CONSTANTS.date.shortMonthDay,
                )} to ${futureDate24Hours?.format(
                  MOMENT_CONSTANTS.date.shortMonthDay,
                )} (${daysDiffrence})`}
          </Typography>
          <Typography variant="h5" color={"primary.secondary"}>
            {truncateLocationName(
              location.state?.reservationState?.location_display_name,
            )}
          </Typography>
          <Typography variant="body2" color={"primary.secondary"}>
            {location.state?.reservationState?.location_address_line_1}
          </Typography>
        </Grid>
        <Stack sx={{ mt: 2 }} spacing={2}>
          <Divider width={"100%"} />
          {vehicleList?.length &&
            vehicleList?.map((item, index) => {
              return (
                <div key={index}>
                  <VehicalTypeCard
                    spotThresholdData={spotThresholdInf[item?.clusterType]}
                    totalCount={selectedVehchilCount}
                    selectedCount={item?.selectedCount}
                    price={item?.price}
                    totalCost={item?.totalCost}
                    children={selectedIcon(item.clusterType)}
                    type={getSpotTitle(item.clusterType)}
                    spotAvailable={"10 spots available"}
                    spotLimit={
                      availabilitySummaryData &&
                      getSpotNumber(item?.clusterType)
                        ? parseInt(getSpotNumber(item?.clusterType)) -
                          parseInt(item?.selectedCount)
                        : 0
                    }
                    chargePerDay={
                      item.reservationType === "DAILY"
                        ? `${item?.price}/${t("pages.reservationType.text03")}`
                        : `${item?.price}/${t("pages.reservationType.text11")}`
                    }
                    onUpdatePrice={(dataItem) => {
                      const updateData = vehicleList.map((data) =>
                        item.clusterType === data.clusterType // to filter perticular vechcal time increase price
                          ? {
                              ...data,
                              totalCost: dataItem?.price,
                              selectedCount: dataItem?.selected,
                              spotLimit:
                                availabilitySummaryData &&
                                getSpotNumber(item?.clusterType),
                            }
                          : data,
                      );
                      setVehiclesList([...updateData]);
                    }}
                  />
                  <Divider width={"100%"} key={`divider-${index}`} />
                </div>
              );
            })}
        </Stack>
        {selectedVehchilCount > 10 && (
          <Typography
            variant="body2"
            color={"orange"}
            sx={{ lineHeight: 1.27 }}
          >
            {t("pages.reservationType.text09")}
          </Typography>
        )}
        <Stack sx={{ mt: 2 }} spacing={2}>
          <Grid
            container
            direction={"row"}
            sx={{ mt: 2, justifyContent: "space-between" }}
          >
            <Typography variant="fontSize16" color={"primary.secondary"}>
              {typeOfReserVationDaySubTotal}
            </Typography>
            <Typography variant="fontSize16" color={"primary.secondary"}>
              {`$ ${subTotalCost}`}
            </Typography>
          </Grid>

          <Grid
            container
            direction={"row"}
            sx={{ mt: 2, justifyContent: "space-between" }}
          >
            <Typography variant="h5" color={"primary.secondary"}>
              {previousData?.reservationType === "DAILY"
                ? `${t("pages.reservationType.text07")} ${`(${t(
                    "pages.reservationType.text12",
                  )} ${daysDiffrence}`})`
                : t("pages.reservationType.text07")}
            </Typography>
            <Typography variant="h5" color={"primary.secondary"}>
              {`$ ${numberDaysCost?.toFixed(2)}`}
            </Typography>
          </Grid>
          <Typography
            variant="body2"
            color={"primary.secondary"}
            style={{ margin: 0 }}
          >
            {t("pages.reservationType.text08")}
          </Typography>
        </Stack>
        {!isKeyboardOpen ? (
          <Stack
            sx={{
              mt: 2,
              mb: 2,
              position: "relavtive",
              justifyContent: "flex-end",
              // width: "90%",
            }}
            spacing={1}
          >
            <RoundButton
              style={{}}
              sx={{ mt: 5, mb: 3 }}
              size="large"
              fullWidth
              variant="contained"
              type="submit"
              color="primary"
              rounded
              onClick={() => {
                if (subTotalCost > 0) {
                  const hours = previousData?.time?.split(":")?.[0];
                  const params = {
                    locationId: previousData?.locationId,
                    reservationType: previousData?.reservationType,
                    noOfDays: previousData?.numOfDays,
                    fromDate: convertYardToUtc({
                      date: moment(previousData?.fromDate).set({
                        hour: hours,
                      }),
                      timeZone: previousData?.reservationState?.timezone,
                    }),
                    calcRequestLines: vehicleList
                      .map((vehicle) => ({
                        spotType: vehicle.clusterType,
                        spotQty: vehicle.selectedCount,
                        totalSpotAvailable: vehicle.spotLimit,
                      }))
                      .filter((vehicle) => vehicle.spotQty > 0),
                  };

                  dispatch(
                    fetchCalculatedPricesRequest(params, (response) => {
                      navigate("/check_out_reservation", {
                        state: {
                          totalTax: response?.totalTaxAmt,
                          subTotalCost: Number(response?.totalPriceAmt),
                          deposit: response?.totalDepositAmt,
                          discount: response?.totalDiscountAmt,
                          net: response?.totalNetAmt,
                          vehicleList: vehicleList,
                          numOfDays: previousData?.numOfDays,
                          fromDate: previousData?.fromDate,
                          locationId: previousData?.locationId,
                          reservationType: previousData?.reservationType,
                          time: previousData?.time,
                          timeZone: previousData?.reservationState?.timezone,
                          reservationState: previousData?.reservationState,
                        },
                      });
                      dispatch(
                        updateReservationCheckout({
                          totalTax: response?.totalTaxAmt,
                          subTotalCost: Number(response?.totalPriceAmt),
                          deposit: response?.totalDepositAmt,
                          discount: response?.totalDiscountAmt,
                          net: response?.totalNetAmt,
                          vehicleList: vehicleList,
                          numOfDays: previousData?.numOfDays,
                          fromDate: previousData?.fromDate,
                          locationId: previousData?.locationId,
                          reservationType: previousData?.reservationType,
                          time: previousData?.time,
                        }),
                      );
                    }),
                  );
                } else {
                  console.log("EKLSEE");
                  enqueueSnackbar(t("pages.reservationType.text10"), {
                    variant: "error",
                    autoHideDuration: 3000,
                    action: SnackbarConfig,
                  });
                }
              }}
            >
              <Typography variant="buttonText" color="common.buttonText">
                {t("commonLabels.text17")}
              </Typography>
            </RoundButton>
          </Stack>
        ) : (
          <></>
        )}
      </Box>
      {isLoading && <CustomLoader />}
    </div>
  );
});

export default ReservationTypePage;
